import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { ChevronDown, MoreHorizontal } from "lucide-react";

/** Menú compacto de acciones secundarias. items: [{ label, icon, onClick, testid, title, hidden }] */
export default function AccionesMenu({ label, items = [], testid = "acciones-menu", variant = "outline" }) {
  const visibles = items.filter((it) => it && !it.hidden);
  if (!visibles.length) return null;
  const Icon = label ? ChevronDown : MoreHorizontal;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} className="h-11 gap-1.5" data-testid={`${testid}-trigger`} title={label || "Más acciones"}>
          {label && <span>{label}</span>}
          <Icon className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[220px]">
        {visibles.map((it) => {
          const ItIcon = it.icon;
          return (
            <DropdownMenuItem key={it.testid || it.label} onClick={it.onClick} title={it.title} className="gap-2 cursor-pointer" data-testid={it.testid}>
              {ItIcon && <ItIcon className="w-4 h-4 text-muted-foreground" />}
              <span>{it.label}</span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
